const s = {
  name: "Checkout",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,0H0v6h40V0z M2,4V2h36v2H2z"/>
		<path class="st0" d="M40,8H0v6h40V8z M2,12v-2h36v2H2z"/>
		<path class="st0" d="M0,16h27v6H0V16z M2,18v2h23v-2H2z"/>
		<path class="st0" d="M19,35.4l5.7-5.7l-1.4-1.4L19,32.6l-2.3-2.3l-1.4,1.4L19,35.4z"/>
		<path class="st0" d="M3,24c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V27c0-1.7-1.3-3-3-3H3z M2,27c0-0.6,0.4-1,1-1
			h34c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V27z"/>
		<path class="st0" d="M30,16h10v6H30V16z M32,18v2h6v-2H32z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Checkout
};
